module.exports = __webpack_public_path__ + "static/media/facebook-page-category.45bddac9.png";